import {
  afterNextRender,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  signal,
  TemplateRef,
  input,
  contentChildren,
  viewChild
} from '@angular/core';
import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel';
import { MatButton } from '@angular/material/button';
import { DeviceService, IconComponent, IconKey } from '@gains-com/ui-angular';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-carousel',
  imports: [MatButton, IconComponent, RouterLink],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
})
export class CarouselComponent implements OnDestroy {
  readonly templates = contentChildren(TemplateRef);

  readonly carouselViewport = viewChild<ElementRef>('carouselViewport');
  readonly leftButton = viewChild<MatButton>('leftButton');
  readonly rightButton = viewChild<MatButton>('rightButton');

  readonly title = input<string | null>(null);
  readonly titleClass = input('ac-title-lg');
  readonly iconUrl = input('');
  readonly slidesToScroll = input<'auto' | number>('auto');
  readonly viewAllLink = input<string | undefined>();

  carousel: EmblaCarouselType;
  hideNavButtons = signal(true);
  canScrollPrev = signal(false);
  canScrollNext = signal(false);

  device = inject(DeviceService);

  private readonly _options: EmblaOptionsType = {
    align: 'start',
    dragFree: true,
  };

  constructor() {
    afterNextRender(() => {
      this.carousel = EmblaCarousel(this.carouselViewport().nativeElement, {
        ...this._options,
        slidesToScroll: this.slidesToScroll(),
      });

      this.carousel
        .on('select', this._toggleNavButtonStates)
        .on('init', this._toggleNavButtonStates)
        .on('reInit', this._toggleNavButtonStates)
        .on('scroll', this._toggleNavButtonStates);
    });
  }

  ngOnDestroy() {
    this.carousel?.destroy();
  }

  scrollLeft() {
    this.carousel.scrollPrev();
    this._toggleNavButtonStates();
  }

  scrollRight() {
    this.carousel.scrollNext();
    this._toggleNavButtonStates();
  }

  private _toggleNavButtonStates = () => {
    const canPrev = this.carousel.canScrollPrev();
    const canNext = this.carousel.canScrollNext();

    this.leftButton().disabled = !canPrev;
    this.rightButton().disabled = !canNext;
    this.canScrollPrev.set(canPrev);
    this.canScrollNext.set(canNext);

    this.hideNavButtons.set(!canPrev && !canNext);
  };
}
